const MuiChip = {
  styleOverrides: {
    outlined: {
      border: '1px solid rgba(0, 0, 0, 0.23)',
    },
  },
};

export default MuiChip;
